import { render, staticRenderFns } from "./aggregators.vue?vue&type=template&id=0d646415&scoped=true"
import script from "./aggregators.vue?vue&type=script&lang=js"
export * from "./aggregators.vue?vue&type=script&lang=js"
import style0 from "./aggregators.vue?vue&type=style&index=0&id=0d646415&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d646415",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/aggregators.vue
// module id = 4RXa
// module chunks = 0